import React, { FormEvent, useState } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { isInIframe } from "../../utils/is-in-iframe";
import { ToolsHeader } from "../components/ToolsHeader";
import { Box } from "./pageSpeedStyle";

const PageSpeedChecker: React.FC = () => {
  const [websiteUrl, setWebsiteUrl] = useState<string>("");

  const isValidUrl = (url: string): boolean => {
    const pattern = /^(https?:\/\/)?([\da-z.-]+\.[a-z.]{2,6})([/\w .-]*)*\/?$/;
    return pattern.test(url);
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let formattedUrl = websiteUrl.trim();

    // Add protocol if missing
    if (!formattedUrl.match(/^https?:\/\//)) {
      formattedUrl = "https://" + formattedUrl;
    }

    if (isValidUrl(formattedUrl)) {
      const redirectUrl = `https://pagespeed.web.dev/analysis?url=${encodeURIComponent(
        formattedUrl
      )}`;
      window.open(redirectUrl, "_blank");
    } else {
      alert("Please enter a valid website URL.");
    }
  };

  return (
    <Box>
      <Container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <div
          style={{
            background: "#fff",
            // padding: "30px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            textAlign: "center",
            width: "100%",
            maxWidth: "600px",
          }}
          className="speedCardBox"
        >
          {!isInIframe && (
            <ToolsHeader
              title="Page Speed Checker"
              description="Effortlessly check your website’s page speed and gain valuable insights
          for better optimization and smarter decisions."
            />
          )}
          {/* <h1
          style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '10px',
          }}
        >
          Page Speed Checker
        </h1>
        <p
          style={{
            fontSize: '1rem',
            color: '#666',
            marginBottom: '20px',
            lineHeight: '1.5',
          }}
        >
          Effortlessly check your website’s page speed and gain valuable insights
          for better optimization and smarter decisions.
        </p> */}
          <Row className="justify-content-center">
            <Col xs={12}>
              <Form
                id="page-speed-checker-form"
                onSubmit={handleSubmit}
                // style={{ display: "flex", justifyContent: "center", gap: "10px" }}
                className="formaSpeedChecker"
              >
                <Form.Group style={{ flex: 1 }} className="inputStyleSpeed">
                  <Form.Control
                    type="text"
                    id="websiteurl"
                    name="websiteurl"
                    placeholder="Enter a web page URL"
                    value={websiteUrl}
                    onChange={(e) => setWebsiteUrl(e.target.value)}
                    required
                    style={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #8CC540",
                      borderRadius: "8px",
                      padding: "0 16px",
                      fontSize: "1rem",
                      letterSpacing: "0.00625em",
                      fontWeight: 400,
                      transition: "border-color 0.3s ease",
                    }}
                  />
                </Form.Group>
                <Button
                  type="submit"
                  style={{
                    height: "48px",
                    padding: "0 20px",
                    background: "#8CC540",
                    border: "1px solid #8CC540",
                    borderRadius: "8px",
                    color: "#fff",
                    fontWeight: 400,
                    fontSize: "1rem",
                    transition: "background 0.3s ease, transform 0.2s ease",
                    cursor: "pointer",
                  }}
                  className="buttonSpeed"
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = "#8CC540";
                    e.currentTarget.style.transform = "scale(1.05)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = "#8CC540";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  Analyze
                </Button>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </Box>
  );
};

export default PageSpeedChecker;
